<template>
  <v-btn icon :to="to">
    <v-icon small class="mr-2 ml-2">
      {{icon}}
    </v-icon>
  </v-btn>
</template>


<script>
export default {
  name:'link-button',
  props: {
    icon: {
      type: String,
    },
    to: {
      type: Object
    },
  },
  data() {
    return {}
  }
}
</script>

